
import { required } from 'vuelidate/lib/validators'

export default {
  credentials: {
    email: {
      required
    },
    password: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/dweller/resources/validations.js